module.exports = __webpack_public_path__ + "static/media/green.01e7f66f.svg";